// Phone country detection helpers using libphonenumber-js.
// Lightweight, reliable, no external API calls required.
import { parsePhoneNumberFromString, AsYouType } from "libphonenumber-js/min";

// ISO-2 -> human-readable country name (top common subset, easily extended)
const ISO_COUNTRY_NAME = {
    AE: "United Arab Emirates",
    AR: "Argentina",
    AT: "Austria",
    AU: "Australia",
    BD: "Bangladesh",
    BE: "Belgium",
    BR: "Brazil",
    CA: "Canada",
    CH: "Switzerland",
    CL: "Chile",
    CN: "China",
    CO: "Colombia",
    CZ: "Czechia",
    DE: "Germany",
    DK: "Denmark",
    EC: "Ecuador",
    EG: "Egypt",
    ES: "Spain",
    FI: "Finland",
    FR: "France",
    GB: "United Kingdom",
    GR: "Greece",
    HK: "Hong Kong",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IN: "India",
    IT: "Italy",
    JP: "Japan",
    KE: "Kenya",
    KR: "South Korea",
    LU: "Luxembourg",
    MA: "Morocco",
    MX: "Mexico",
    MY: "Malaysia",
    NG: "Nigeria",
    NL: "Netherlands",
    NO: "Norway",
    NZ: "New Zealand",
    PE: "Peru",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PT: "Portugal",
    QA: "Qatar",
    RO: "Romania",
    RU: "Russia",
    SA: "Saudi Arabia",
    SE: "Sweden",
    SG: "Singapore",
    TH: "Thailand",
    TR: "Turkey",
    TW: "Taiwan",
    UA: "Ukraine",
    US: "United States",
    UY: "Uruguay",
    VE: "Venezuela",
    VN: "Vietnam",
    ZA: "South Africa",
};

/**
 * Format a phone number as the user types. Adds a leading + if missing.
 */
export const formatPhone = (raw) => {
    if (!raw) return "";
    const trimmed = raw.trim().replace(/[^\d+]/g, "");
    const value = trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
    try {
        const t = new AsYouType();
        return t.input(value);
    } catch (_e) {
        return value;
    }
};

/**
 * Try to detect the country (ISO-2 + readable name) from any partial/full phone number.
 * Returns { iso, name, valid } or { iso:null, name:null, valid:false } when ambiguous.
 */
export const detectCountryFromPhone = (raw) => {
    if (!raw) return { iso: null, name: null, valid: false };
    const value = raw.trim().startsWith("+") ? raw.trim() : `+${raw.trim().replace(/[^\d]/g, "")}`;
    try {
        const parsed = parsePhoneNumberFromString(value);
        if (parsed && parsed.country) {
            return {
                iso: parsed.country,
                name: ISO_COUNTRY_NAME[parsed.country] || parsed.country,
                valid: parsed.isValid(),
            };
        }
    } catch (_e) {
        /* ignore */
    }
    return { iso: null, name: null, valid: false };
};
